// extracted by mini-css-extract-plugin
module.exports = {"footer":"MutateMid_footer__1gELq","legacyBtn":"MutateMid_legacyBtn__24u9C"};